import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d96108e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content profile" }
const _hoisted_2 = { class: "profile__content" }
const _hoisted_3 = { class: "profile__content-left-block" }
const _hoisted_4 = {
  key: 0,
  class: "profile__content-info"
}
const _hoisted_5 = { class: "medium mt--10 mb--10" }
const _hoisted_6 = { class: "profile__content-mobile-menu" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "items-in-line flex-start mt--0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "title" }, null, -1))

import {
  Analytics,
  CompareList,
  FavoriteAds,
  MyAnnouncements,
  MyDeveloper,
  MyResidentialComplex,
  Notifications,
  PartnerProgram,
  Profile,
  ProfileMenu,
  SearchHistoryList,
  Services,
  Support,
} from '@/components/ProfileComponents';
import { Messenger } from '@/components';
import { computed, markRaw, onMounted, ref, Ref, watch } from 'vue';
import { ProfileMenuItemsType, ProfileMenuItemType } from '@/types';
import { useRoute } from 'vue-router';
import { UserType, useUserStore } from '@/store/modules/user';
import { useChatStore } from '@/store/modules/chat';


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const userInfo = computed((): UserType | undefined => {
  return useUserStore().user;
});
const chatCount = computed((): number => {
  return useChatStore().chatIdsWithNewMessage.length;
});

const profileMenuItems = computed((): ProfileMenuItemsType => {
  return [
    [
      {
        id: 'profile',
        title: 'Настройка профиля',
        component: markRaw(Profile),
      },
    ],
    [
      {
        id: 'chat',
        title: 'Чаты',
        count: chatCount.value,
        component: markRaw(Messenger),
      },
      {
        id: 'notifications',
        title: 'Уведомления',
        count: userInfo.value?.notificationUser.open,
        component: markRaw(Notifications),
      },
      {
        id: 'favorite',
        title: 'Избранное',
        count: useUserStore().user?.favorite_ids.length,
        component: markRaw(FavoriteAds),
      },
      {
        id: 'compare',
        title: 'Списки сравнений',
        count: useUserStore().user?.comparisons,
        component: markRaw(CompareList),
      },
      {
        id: 'searchHistory',
        title: 'История поиска',
        component: markRaw(SearchHistoryList),
      },
    ],
    [
      {
        id: 'myDeveloper',
        title: 'Мои объекты',
        component: markRaw(MyDeveloper),
        hide: !useUserStore().user?.is_construction_company,
      },
      {
        id: 'MyResidentialComplex',
        title: 'Мой ЖК',
        component: markRaw(MyResidentialComplex),
        hide: !useUserStore().user?.is_construction_company,
      },
      {
        id: 'myAnnouncements',
        title: 'Мои объявления',
        component: markRaw(MyAnnouncements),
      },
      {
        id: 'partnerProgram',
        title: 'Партнерская программа',
        component: markRaw(PartnerProgram),
        hide: !useUserStore().user?.access.includes('PartnerProgramEdit'),
      },
    ],
    [
      {
        id: 'analytics',
        title: 'Аналитика',
        component: markRaw(Analytics),
      },
      {
        id: 'services',
        title: 'Сервисы',
        component: markRaw(Services),
      },
    ],
    [
      {
        id: 'support',
        title: 'Поддержка',
        component: markRaw(Support),
      },
    ],
  ];
});
let activeMenuItem: Ref<ProfileMenuItemType | undefined> = ref(undefined);

const currentProperties = computed(() => {
  if (activeMenuItem.value?.id === 'classificationResults') {
    return {
      fromProfile: true,
    };
  }

  return {};
});

const route = useRoute();
const routerParamId = computed(() => {
  return route.params.id;
});

const updateMenuItem = () => {
  let newMenuItem;

  if (routerParamId.value) {
    profileMenuItems.value.forEach(category => {
      const foundMenuItem = category.find(el => el.id === routerParamId.value);

      if (foundMenuItem && !foundMenuItem.hide) {
        newMenuItem = foundMenuItem;
      }
    });
  }

  activeMenuItem.value = newMenuItem ?? profileMenuItems.value[0][0];
};

onMounted(async () => {
  updateMenuItem();
});

watch(
  () => routerParamId.value,
  () => {
    updateMenuItem();
  },
);
watch(
  () => userInfo.value?.notificationUser.open,
  (newValue, oldValue) => {
    if (newValue && oldValue && newValue > oldValue) {
      useUserStore().getNotifications();
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_menu = _resolveComponent("base-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (userInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(_component_base_image, {
                  key: userInfo.value.logo,
                  contain: !userInfo.value.logo,
                  cover: !!userInfo.value.logo,
                  src: userInfo.value.logo || require('@/assets/img/profile/avatar.png'),
                  class: "profile__content-avatar",
                  height: "80",
                  name: "ava",
                  width: "80"
                }, null, 8, ["contain", "cover", "src"]))
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(userInfo.value.name || 'Имя пользователя'), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_base_divider, { class: "mt--10 mb--10 profile__content-divider" }),
        _createVNode(_unref(ProfileMenu), {
          activeMenuItem: _unref(activeMenuItem),
          profileMenuItems: profileMenuItems.value,
          class: "profile__content-menu",
          onChangeActiveMenuItem: _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeMenuItem) //@ts-ignore
 ? activeMenuItem.value = $event : activeMenuItem = $event))
        }, null, 8, ["activeMenuItem", "profileMenuItems"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_base_menu, null, {
            menuItems: _withCtx((menuItemsProps) => [
              _createVNode(_unref(ProfileMenu), {
                activeMenuItem: _unref(activeMenuItem),
                profileMenuItems: profileMenuItems.value,
                onChangeActiveMenuItem: ($event: any) => {
                  menuItemsProps.events.handleClick();
                  _isRef(activeMenuItem) //@ts-ignore
 ? activeMenuItem.value = $event : activeMenuItem = $event;
                }
              }, null, 8, ["activeMenuItem", "profileMenuItems", "onChangeActiveMenuItem"])
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(activeMenuItem))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", null, _toDisplayString(_unref(activeMenuItem).title), 1),
              _hoisted_9
            ]),
            _createElementVNode("div", null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(activeMenuItem).component), _mergeProps({
                key: _unref(activeMenuItem).id
              }, currentProperties.value), null, 16))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})